import { Grid2 as Grid, useMediaQuery } from "@mui/material";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Sidebar } from "./Sidebar";
import { useContext } from "react";
import { AppContext } from "../App";
import theme from "../theme";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { isSubmissionCreated } = useContext(AppContext);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const showSidebar = !isMobile && !isSubmissionCreated;

  return (
    <Grid container flexDirection="row" sx={{ height: "100%", width: "100%" }}>
      <Grid
        container
        flexDirection="column"
        size={showSidebar ? { xs: 12, sm: 8, lg: 9 } : "auto"}
        sx={{ height: "100%", width: "100%" }}
        spacing={6}
      >
        {!isSubmissionCreated && <Header />}

        <Grid
          p={isSubmissionCreated ? 0 : 2}
          sx={
            isSubmissionCreated
              ? { bgcolor: "#F4F9F8", flex: 1, width: "100%", minHeight: 0 }
              : undefined
          }
        >
          {children}
        </Grid>

        <Footer />
      </Grid>

      {showSidebar && <Sidebar />}
    </Grid>
  );
};
